import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrudService } from 'src/app/services/crud.service';
import CustomStore from 'devextreme/data/custom_store';
import { firstValueFrom, map } from 'rxjs';
import { LocalDataService } from 'src/app/services/local-data.service';
import { environment } from 'src/environments/environment';
import { ConfirmationService } from 'src/app/services/confirmation.service';
import { HorizontalMenuService } from 'src/app/services/horizontalmenu.service';
import { DxDataGridComponent, DxDataGridModule } from 'devextreme-angular';
import { RebateNames } from 'src/app/models/rebate-names.model';
import { PromotionGroupItemsComponent } from '../promotion-group-items/promotion-group-items.component';
import { NotifyService } from 'src/app/services/notify.service';
import { PageHeaderComponent } from 'src/app/shared/page-header/page-header.component';

@Component({
    selector: 'app-promotion-groups',
    templateUrl: './promotion-groups.component.html',
    styleUrls: ['./promotion-groups.component.css'],
    imports: [ CommonModule, DxDataGridModule, PromotionGroupItemsComponent, PageHeaderComponent ],
    standalone: true
})
export class PromotionGroupsComponent implements OnInit {
  dataSource: any;
  promotionCategories: any;
  suppliers: Supplier[] = [];
  // Rebate columns are dynamic; the grid only renders once these are resolved so that
  // state storing restores against the full column set (late columns reset saved state).
  rebateNames: RebateNames[] | null = null;
  editPromotionGroups:boolean;
  currencyFormat = { type: 'currency', precision: 2 };
  private apiUrl: string = environment.baseApiUrl;
  @ViewChild("promotionGroupGrid", { static: false }) public dataGrid: DxDataGridComponent;
  
  constructor(private crudService: CrudService,
    private localData: LocalDataService,
    private confirmationService:ConfirmationService,
    private horizontalMenuService:HorizontalMenuService,
    private notifyService: NotifyService) {
    this.dataSource = new CustomStore<any>({
      key: 'id',
      load: async () => {
        return await new Promise((resolve) => {
          this.crudService.newGetData(`${this.apiUrl}promotion-groups?get_all=1`).subscribe((result: any) => {
            resolve(result);
          });
        });
    },
      insert: async (values: any) => {
        console.log(values);
        const rebateNames: RebateNames[] = this.rebateNames ?? [];
        const rebateData: any[] = [];
        const rebateNameskeys = Object.keys(values);
        rebateNameskeys.forEach((rebateNameskey: any) => {
          const rebateDetails = rebateNames.find((rebate) => rebate.rebate_name === rebateNameskey);
          if(rebateDetails) {
            rebateData.push({
              rebate_id: rebateDetails.id,
              rebate_amount: values[rebateNameskey]
            });
          }
        });
        values.rebates = rebateData;
        return await new Promise(async (resolve) => {
          this.crudService.insertData(`${this.apiUrl}promotion-groups`, values).subscribe((result: any) => {
            resolve(result);
          });
        });
      },
      update: async (key, values) => {
        console.log(values);
        const rebateNames: RebateNames[] = this.rebateNames ?? [];
        const rebateData: any[] = [];
        const rebateNameskeys = Object.keys(values);
        rebateNameskeys.forEach((rebateNameskey: any) => {
          const rebateDetails = rebateNames.find((rebate) => rebate.rebate_name === rebateNameskey);
          if(rebateDetails) {
            rebateData.push({
              rebate_id: rebateDetails.id,
              rebate_amount: values[rebateNameskey],
              promotion_group_id: key
            });
          }
        });
        values.rebates = rebateData;
        console.log(values);
        return await new Promise(async (resolve) => {
          this.crudService.updateData(`${this.apiUrl}promotion-groups`, key, values).subscribe((result: any) => {
            resolve(result);
          });
        });
      },
      remove: async (key) => {
        return await new Promise(async (resolve) => {
          const result: any = this.crudService.deleteData(`${this.apiUrl}promotion-groups`, key).subscribe((result: any) => {
            this.notifyService.tellUser({
              success: true,
              data: 'Promotion group deleted successfully!'
            });
            resolve(result);
          });
        });
      }
    })

    this.horizontalMenuService.editPromotionGroups$.subscribe(async (value: boolean) => {
      this.promotionCategories =  await this.crudService.getData(`${this.apiUrl}planning-categories`).toPromise();
      this.editPromotionGroups = value;
    });
  }

  async ngOnInit(): Promise<void> {
    const [suppliers, rebateNames] = await Promise.all([
      firstValueFrom(this.crudService.newGetData(`${this.apiUrl}suppliers`)),
      firstValueFrom(this.crudService.newGetData(`${this.apiUrl}rebates?type=0`).pipe(map((data: any) => data.data)))
    ]);
    this.suppliers = suppliers;
    this.rebateNames = rebateNames;
  }

  onHiding(event:any){
    this.confirmationService.checkUnsaved(event, this.dataGrid, (value:boolean) => this.horizontalMenuService.seteditPromotionGroups(value))
  }   
}

export class Supplier
{
  supplier_code: string;
  supplier_name: string;
}
